import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Colophon } from "../../types/colophon";
import EntityTable from "../EntityTable";
import {
  extractColophonEditLink,
  extractColophonViewLink,
} from "../entitiesReferences/InternalEntityLink";
import { renderRowViewAndUpdateActions } from "../../common/TableUtils";
import { MRT_ColumnDef } from "material-react-table";
import useColophonQuery from "../../hooks/query/useColophonQuery";
import colophonColumns, {
  colophonFilterSpec,
} from "../../common/entities/ColophonColumns";
import useServerFilters from "../../hooks/useServerFilters";

interface ColophonTableProps {
  columns?: MRT_ColumnDef<Colophon, any>[];
  filters?: Partial<Colophon>;
  enableRowActions?: boolean;
}

const ColophonTable: React.FC<ColophonTableProps> = ({
  columns = colophonColumns,
  filters = {},
  enableRowActions = true,
}) => {
  const navigate = useNavigate();

  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, colophonFilterSpec);
  const { useFetchAll } = useColophonQuery();
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const renderRowActions = useMemo(
    () =>
      renderRowViewAndUpdateActions(
        (colophon: Colophon) => navigate(extractColophonViewLink(colophon)),
        (colophon: Colophon) => navigate(extractColophonEditLink(colophon))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      enableRowSelection={false}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};

export default ColophonTable;
